import { RemoveInsurerRep, RemoveInsurerRepVariables } from "_graphql/mutation/__generated__/RemoveInsurerRep";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { removeInsurerRep } from "_graphql/visal/mutations/insurer";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemoveContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>()
    const [remove, { loading }] = useMutation<RemoveInsurerRep, RemoveInsurerRepVariables>(removeInsurerRep, {
        refetchQueries: ["GetInsurerAssociates"]
    });


    const handleSubmit = async () => {
        await remove({
            variables: {
                insurerRepId: searchParams?.id || ""
            },
        }).then(({ data }) => {
            if (data?.removeInsurerRep) {
                toast.success("Manager removed successfully");
                refetch?.();
                setOpen?.(false);
            } else {
                toast.error("Failed to remove manager");
            }
        });
    }

    return (
        <PopUp
            open={open}
            setOpen={setOpen}
            title="Remove Manager"
            cancelText="No, Don't Remove Manager"
            description="This action would completely remove manager details from system"
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={handleSubmit}
                    >
                        {loading ? "Removing Manager..." : "Remove Manager"}
                    </button>
                </>
            )}
        />
    );
}
